import appConfig from '@src/app.config.ES6';

export default {
	// Application Version
	APP_VERSION: '1.6.2',

	// PUBLIC endpoints
	PUBLIC_RECIPE_BY_ID_URL: `${appConfig.API_BASE_URL}/api/publics/recipe/:id`,

	GET_USER_PROFILE_URL: `${appConfig.API_BASE_URL}/api/profiles/current`,
	UPDATE_USER_PROFILE_URL: `${appConfig.API_BASE_URL}/api/profiles/current/update`,

	SIGNUP_URL: `${appConfig.API_BASE_URL}/api/signup`,

	USER_LOGIN_URL: `${appConfig.API_BASE_URL}/api/Accounts/login`,
	ADMIN_LOGIN_URL: `${appConfig.API_BASE_URL}/api/Accounts/admin/login`,
	VALIDATE_AUTH_TOKEN_URL: `${appConfig.API_BASE_URL}/api/auth/token`,

	AUTOCOMPLETE_LISTS_URL: `${appConfig.API_BASE_URL}/api/admin/autoCompleteLists`,

	// INGREDIENT ENDPOINTS
	MANAGE_INGREDIENTS_URL: `${appConfig.API_BASE_URL}/api/admin/manageIngredients?params=:queryString`,
	INGREDIENT_DETAILS_URL: `${appConfig.API_BASE_URL}/api/admin/ingredient/:id/details`,
	ADD_INGREDINT_URL: `${appConfig.API_BASE_URL}/api/admin/ingredient/add`,
	UPDATE_INGREDINT_URL: `${appConfig.API_BASE_URL}/api/admin/ingredient/:id/update`,
	ADD_INGREDINT_BRANDING_URL: `${appConfig.API_BASE_URL}/api/admin/ingredient/:id/brand-ingredient/add`,
	UPDATE_INGREDINT_BRANDING_URL: `${appConfig.API_BASE_URL}/api/admin/ingredient/:id/brand-ingredient/update`,
	DELETE_INGREDINT_BRANDING_URL: `${appConfig.API_BASE_URL}/api/admin/ingredient/:id/brand-ingredient/:brandIngredientId`,

	UPDATE_MAPPED_INGREDIENT_URL: `${appConfig.API_BASE_URL}/api/admin/mappedIngredient/:id/update`,

	// RECIPE ENDPOINTS
	RECIPES_SEARCH_OPTION_URL: `${appConfig.API_BASE_URL}/api/admin/getRecipeSearchOptions`,
	MANAGE_RECIPES_URL: `${appConfig.API_BASE_URL}/api/admin/manageRecipes?params=:queryString`,
	PUBLISHED_RECIPES_URL: `${appConfig.API_BASE_URL}/api/admin/publishedRecipes?params=:queryString`,
	DRAFT_RECIPES_URL: `${appConfig.API_BASE_URL}/api/admin/draftRecipes?params=:queryString`,
	UNUSED_RECIPES_URL: `${appConfig.API_BASE_URL}/api/admin/unusedRecipes?params=:queryString`,
	FLAGGED_RECIPES_URL: `${appConfig.API_BASE_URL}/api/admin/flaggedRecipes?params=:queryString`,
	ARCHIVED_RECIPES_URL: `${appConfig.API_BASE_URL}/api/admin/archivedRecipes?params=:queryString`,

	RECIPE_DETAILS_URL: `${appConfig.API_BASE_URL}/api/admin/recipe/:id/details`,
	SAVE_RECIPE_DETAILS_URL: `${appConfig.API_BASE_URL}/api/admin/recipe/:id/update`,
	BULK_SAVE_RECIPE_DETAILS_URL: `${appConfig.API_BASE_URL}/api/admin/recipe/bulkUpdate`,
	CALCULATE_RECIPE_NUTRITION_URL: `${appConfig.API_BASE_URL}/api/admin/importNutrition/recipe/:id`,
	RESET_RECIPE_NUTRITION_URL: `${appConfig.API_BASE_URL}/api/admin/resetNutrition/recipe/:id`,
	UPDATE_RECIPE_NUTRITION_UNITS: `${appConfig.API_BASE_URL}/api/admin/recipe/:id/updateNutrition`,

	IMPORT_RECIPES_URL: `${appConfig.API_BASE_URL}/api/admin/importRecipes`,

	// MEAL ENDPOINTS
	MANAGE_MEALS_URL: `${appConfig.API_BASE_URL}/api/admin/manageMeals`,
	MEAL_DETAILS_URL: `${appConfig.API_BASE_URL}/api/meals/:id/details`,
	UPDATE_MEAL_URL: `${appConfig.API_BASE_URL}/api/admin/meal/:id/update`,
	ADD_MEAL_URL: `${appConfig.API_BASE_URL}/api/admin/meal/add`,
	BULK_UPDATE_MEALS_URL: `${appConfig.API_BASE_URL}/api/admin/meals/update`,
	UPDATE_MEAL_RECIPES_URL: `${appConfig.API_BASE_URL}/api/admin/meal/:id/updateRecipes`,

	// PLATELIST ENDPOINTS
	MANAGE_PLATELISTS_URL: `${appConfig.API_BASE_URL}/api/publics/platelistDiscovery?filterResults=false`,
	PLATELIST_PAYLOAD_URL: `${appConfig.API_BASE_URL}/api/admin/platelist/:id/payload?includeMeals=false`,
	ADMIN_PLATELIST_DAYS_URL: `${appConfig.API_BASE_URL}/api/profiles/admin/platelist/findOrCreate`,
	ADMIN_PLATELIST_CREATE_URL: `${appConfig.API_BASE_URL}/api/profiles/admin/platelist/create`,
	ADMIN_PLATELIST_UPDATE_URL: `${appConfig.API_BASE_URL}/api/profiles/admin/platelist/updateMetadata`,
	ADMIN_UPDATE_PLATELIST_DISH_URL: `${appConfig.API_BASE_URL}/api/profiles/admin/platelist/dish`,

	// TAG ENDPOINTS
	MANAGE_TAGS_URL: `${appConfig.API_BASE_URL}/api/admin/manageTags`,
	UPDATE_TAG_URL: `${appConfig.API_BASE_URL}/api/admin/tag/:id/update`,
	ADD_TAG_URL: `${appConfig.API_BASE_URL}/api/admin/tag/add`,
	DELETE_TAG_URL: `${appConfig.API_BASE_URL}/api/admin/tag/:id/delete`,

	// HEALTH ENDPOINTS
	MANAGE_HEALTHS_URL: `${appConfig.API_BASE_URL}/api/admin/manageHealths`,
	UPDATE_HEALTH_URL: `${appConfig.API_BASE_URL}/api/admin/health/:id/update`,
	ADD_HEALTH_URL: `${appConfig.API_BASE_URL}/api/admin/health/add`,
	DELETE_HEALTH_URL: `${appConfig.API_BASE_URL}/api/admin/health/:id/delete`,

	// METRIC ENDPOINTS
	MANAGE_METRICS_URL: `${appConfig.API_BASE_URL}/api/admin/manageMetrics`,
	UPDATE_METRIC_URL: `${appConfig.API_BASE_URL}/api/admin/metric/:id/update`,
	ADD_METRIC_URL: `${appConfig.API_BASE_URL}/api/admin/metric/add`,
	DELETE_METRIC_URL: `${appConfig.API_BASE_URL}/api/admin/metric/:id/delete`,

	// CATEGORY ENDPOINTS
	MANAGE_INGREDIENT_CATEGORIES_URL: `${appConfig.API_BASE_URL}/api/admin/manageIngredientCategories`,
	UPDATE_INGREDIENT_CATEGORY_URL: `${appConfig.API_BASE_URL}/api/admin/ingredient-category/:id/update`,
	ADD_INGREDIENT_CATEGORY_URL: `${appConfig.API_BASE_URL}/api/admin/ingredient-category/add`,
	DELETE_INGREDIENT_CATEGORY_URL: `${appConfig.API_BASE_URL}/api/admin/ingredient-category/:id/delete`,

	// DIETS ENDPOINTS
	MANAGE_DIETS_URL: `${appConfig.API_BASE_URL}/api/admin/manageKitchens`,
	UPDATE_DIETS_URL: `${appConfig.API_BASE_URL}/api/admin/kitchen/:id/update`,
	ADD_DIETS_URL: `${appConfig.API_BASE_URL}/api/admin/kitchen/add`,
	DELETE_DIETS_URL: `${appConfig.API_BASE_URL}/api/admin/kitchen/:id/delete`,

	// IMAGE UPLOAD ENDPOINT
	GET_IMAGE_UPLOAD_URL: `${appConfig.API_BASE_URL}/api/images/Sign`,

	// PLATELIST COPY DAY ENDPOINT
	ADMIN_COPY_DAY_URL: `${appConfig.API_BASE_URL}/api/profiles/admin/platelist/copy-day`,

	PROFILES: 'profiles/',
	CURRENT: 'current/',
};
